import { HotelDetailsViewModel } from 'models';

export const adaptPropertyInfo = (data): HotelDetailsViewModel => {
  const propertyInfoDetails =
    data.data && data.data.propertyInfo && data.data.propertyInfo.pwaOnlyBffResponse && data.data.propertyInfo.pwaOnlyBffResponse.details;

  return propertyInfoDetails ? JSON.parse(propertyInfoDetails) : data;
};
